<ion-content class="ion-padding">
    <div class="max-page-width">
        <ion-item lines="none" mode="ios" class="title-with-back-button">
            <ion-button fill="clear" mode="ios" color="primary" (click)="goBack()">
                <ion-icon class="bp-arrow-left"></ion-icon>
            </ion-button>
            <ion-label class="ion-text-center ion-text-wrap"> {{ getText(processConfig?.globalizationConfig, 'title') | uppercase }} </ion-label>
        </ion-item>

        <ion-card mode="ios" class="team-card">
            <ion-card-header color="">
                <ion-card-title class="manager-book">
                    {{ '360evaluation.evaluationsToDo' | translate }}
                    <ion-button text-wrap mode="ios" color="primary" *ngIf="nineboxEnabled" (click)="getTeamComparisonExcel()">
                        {{ 'managerEvaluation.getBookReport' | translate }}
                    </ion-button>
                </ion-card-title>
                <ion-searchbar
                    mode="ios"
                    class="section-search-custom"
                    [placeholder]="'generic.searchByName' | translate"
                    (keyup)="updateSearch($event.target.value)"
                ></ion-searchbar>
            </ion-card-header>
            <ion-card-content class="ion-no-padding">
                <ion-grid class="team">
                    <ion-row class="header">
                        <ion-col size="1.5"></ion-col>
                        <ion-col size="3.5"> {{ 'generic.evaluee' | translate }} </ion-col>
                        <ion-col size="1.5"> {{ 'generic.relationship' | translate }} </ion-col>
                        <ion-col size="5.5"></ion-col>
                    </ion-row>
                    <ion-row *ngFor="let user of displayedUsers">
                        <ion-col size="1.5">
                            <img [src]="getImageUrl(user.imageUrl)" default="" class="avatar" />
                        </ion-col>
                        <ion-col size="3.5">
                            <h3>{{ user.name }}</h3>
                        </ion-col>
                        <ion-col size="1.5">
                            <h3>{{ user.relationship }}</h3>
                        </ion-col>
                        <ion-col size="5.5" flexed>
                            <ng-container *ngIf="user.selfEvaluationStatus === ManagedUserStatus.NotSent">
                                <ion-button text-wrap mode="ios" color="warning" fill="clear" expand="block"> {{ 'goalsInput.waitingValidation' | translate }} </ion-button>
                            </ng-container>

                            <ng-container *ngIf="user.selfEvaluationStatus === ManagedUserStatus.Sent" [ngSwitch]="user.status">
                                <ng-container *ngIf="status === ProcessStatus.WaitingInput">
                                    <ion-button text-wrap mode="ios" expand="block" *ngSwitchCase="ManagedUserStatus.NotSent" (click)="goToEvaluation(user)">
                                        {{ 'generic.evaluate' | translate }}
                                    </ion-button>
                                </ng-container>
                                <ng-container *ngSwitchCase="ManagedUserStatus.Sent">
                                    <ion-button text-wrap mode="ios" color="success" fill="clear" expand="block">
                                        {{ 'generic.evaluated' | translate }}
                                        <ion-icon slot="end" class="bp-check"></ion-icon>
                                    </ion-button>

                                    <a class="highlight" (click)="goToEvaluation(user)"> {{ 'dashboard.See' | translate }} </a>

                                    <ng-container *ngIf="canReopenOrDeleteEvaluation">
                                        <a class="highlight reopen" (click)="reopenEvaluation(user)"> {{ 'processParticipants.reopen' | translate }} </a>
                                    </ng-container>

                                    <div *ngIf="hasCalibration" class="viewCalibration" (click)="viewUserCalibration(user)">
                                        <ion-icon slot="end" class="bp-view"></ion-icon>
                                        {{ 'calibration.see' | translate }}
                                    </div>

                                    <ion-button *ngIf="showCalibrationFullReport" fill="clear" color="secondary" mode="ios" (click)="viewFullReport(user)">
                                        <img src="./assets/imgs/Relatorio_Completo_icon.svg" />&nbsp; {{'calibration.fullReport' | translate }}
                                    </ion-button>
                                </ng-container>

                                <!-- Funcionalidade desabilitada -->

                                <!-- <ion-icon
                                    *ngIf="canReopenOrDeleteEvaluation"
                                    color="danger"
                                    style="padding-left: 10px;"
                                    class="bp-delete bigger"
                                    (click)="deleteEvaluation(user)"
                                >
                                </ion-icon> -->
                            </ng-container>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-card-content>
        </ion-card>
    </div>
</ion-content>
